<template>
  <div class="flex flex-row flex-wrap gap-[12px]">
    <div
      v-for="(item, index) in serviceNames"
      class="h-[40px] text-center py-[8px] px-[12px] border rounded-[100px] gap-2 cursor-pointer"
      :class="{
        'bg-[#FFE34E] border-[#FCEB8F] text-[##191817]': isSelected(index),
        'bg-transparent text-white': !isSelected(index),
      }"
      :key="index"
      @click="selectService(item, index)"
    >
      <p class="font-[Inter] text-[1rem] leading-[1.5rem] font-medium text-center text-nowrap">
        {{ item.name }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { trackContentClick } from '@/utils/analytics';

export default {
  computed: {
    ...mapGetters('serviceHighlights', ['serviceNames', 'selectedServiceIndex']),
  },
  methods: {
    selectService(item, index) {
      trackContentClick({
        contentType: 'service_highlight_tab',
        contentId: item.dataEventTracking || item.name,
        title: item.name,
        sourceSection: 'service-highlights-tabs',
        position: index,
        destination: '/service-highlights',
        isExternal: false,
        source: 'service-highlights-tabs',
      });
      this.$store.dispatch('serviceHighlights/updateSelectedServiceIndex', index);
    },
    isSelected(index) {
      return this.selectedServiceIndex === index;
    },
  },
};
</script>
